import Vue from 'vue';
import Router from 'vue-router';
import store from "./store";
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "login",
      component: () => import('./views/Login.vue')
    },
    {
      path: "/login",
      name: "login2",
      component: () => import('./views/Login.vue')
    },
    {
      path: '/login/:instalacion',
      name: 'loginsys4',
      component: () => import('./views/Login.vue'),
      props: true
    },
    // {
    //   path: '/',
    //   name: 'dashboard',
    //   component: () => import('./views/Dashboard.vue')
    // },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('./views/Dashboard.vue')
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('./views/Logout.vue')
    },
    {
      path: '/tablageneral',
      name: 'tablageneral',
      component: () => import('./views/tablas/TablaGeneral.vue')
    },
    {
      path: '/tablatodos',
      name: 'tablatodos',
      component: () => import('./views/tablas/TablaTodos.vue')
    },
    {
      path: '/tablastock',
      name: 'tablastock',
      component: () => import('./views/tablas/TablaStock.vue')
    },
    {
      path: '/tablapedido',
      name: 'tablapedido',
      component: () => import('./views/tablas/TablaPedido.vue')
    },
    {
      path: '/tablaalbaran',
      name: 'tablaalbaran',
      component: () => import('./views/tablas/TablaAlbaran.vue')
    },
    {
      path: '/tablareservastock',
      name: 'tablareservastock',
      component: () => import('./views/tablas/TablaReservaStock.vue')
    },
    {
      path: '/tablareservacompra',
      name: 'tablareservacompra',
      component: () => import('./views/tablas/TablaReservaCompra.vue')
    },
    {
      path: '/tablaodt',
      name: 'tablaodt',
      component: () => import('./views/tablas/TablaOdt.vue')
    },
    {
      path: '/tablapivotgrid',
      name: 'tablapivotgrid',
      component: () => import('./views/tablas/TablaPivotGrid.vue')
    },
    {
      path: '/grafico1',
      name: 'grafico1',
      component: () => import('./views/graficos/Grafico1.vue')
    },
    {
      path: '/graficodistribucionventas',
      name: 'graficodistribucionventas',
      component: () => import('./views/graficos/GraficoDistribucionVentas.vue')
    },
    {
      path: '/graficoalmacen',
      name: 'graficoalmacen',
      component: () => import('./views/graficos/GraficoAlmacen.vue')
    },
    {
      path: '/graficotransporte',
      name: 'graficotransporte',
      component: () => import('./views/graficos/GraficoTransporte.vue')
    },
    {
      path: '/personas',
      name: 'personas',
      component: () => import('./views/Personas.vue')
    },
    {
      path: '/personal',
      name: 'personal',
      component: () => import('./views/Personal.vue')
    },
    {
      path: '/persona',
      name: 'persona',
      component: () => import('./views/Persona.vue'),
      props: true
    },
    {
      path: '/anadirempleado',
      name: 'anadirempleado',
      component: () => import('./views/CreatePersona.vue')
    },
    {
      path: '/calenlab',
      name: 'calenlab',
      component: () => import('./views/MantCalenlab.vue')
    },
    {
      path: '/mobilefichaje',
      name: 'mobilefichaje',
      component: () => import('./views/FrameMobileFichaje.vue')
    },
    {
      path: '/looks',
      name: 'looks',
      component: () => import('./views/look/Looks.vue')
    },
    {
      path: '/lookcreator',
      name: 'lookcreator',
      component: () => import('./views/look/LookCreator.vue'),
      props: true
    },
    {
      path: '/lookcreatorcliente',
      name: 'lookcreatorcliente',
      component: () => import('./views/look/LookCreatorCliente.vue'),
      props: true
    },
    {
      path: '/lookviewer/:lookid',
      name: 'lookviewer',
      component: () => import('./views/look/LookViewer.vue'),
      props: true
    },
    {
      path: '/weblinks',
      name: 'weblinks',
      component: () => import('./views/WebLinks.vue')
    },
    {
      path: '/notas',
      name: 'notas',
      component: () => import('./views/Notas.vue')
    }, 
    {
      path: '/citaprevia',
      name: 'citaprevia',
      component: () => import('./views/CitaPrevia.vue')
    },
    {
      path: '/instagram',
      name: 'instagram',
      component: () => import('./views/Instagram.vue')
    },
    {
      path: '/tienda',
      name: 'tienda',
      component: () => import('./views/tienda/pages/index.vue')
    },
    {
      path: '/foro',
      name: 'foro',
      component: () => import('./views/Foro.vue')
    },
    {
      path: '/timeline',
      name: 'timeline',
      component: () => import('./views/TimeLine.vue')
    },
    {
      path: '/cliente',
      name: 'cliente',
      component: () => import('./views/clienteling/Cliente.vue'),
      // props: (route) => ({
      //   cliente: route.params.cliente,
      // })
    }, 
    { 
      path: '/lista-clientes',
      name: 'listaclientes',
      component: () => import('./views/clienteling/ListaClientes.vue'),
    },
    {
      path: '/mobile-store',
      name: 'staffcontrol',
      component: () => import('./views/Personal.vue'),
      props: (route) => ({
        tiUid: route.query.uid,
      })
    },
    { 
      path: '/informes',
      name: 'informes',
      component: () => import('./views/Informes.vue'),
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('./components/Settings.vue')
    }, 
    // {
    //   path: '/qr-scanner',
    //   name: 'qrscanner',
    //   component: () => import('./components/QrScanner.vue')
    // },
    // {
    //   path: '/code-scanner',
    //   name: 'codescanner',
    //   component: () => import('./components/CodeScanner.vue')
    // },
    // {
    //   path: '/prueba-ip',
    //   name: 'pruebaip',
    //   component: () => import('./views/PruebaIp.vue')
    // },
    // {
    //   path: '/venta-neta',
    //   name: 'ventaneta',
    //   component: () => import('./components/VentaNeta.vue')
    // },
    // {
    //   path: '/venta-neta',
    //   name: 'analisistienda',
    //   component: () => import('./components/AnalisisTienda.vue')
    // },
    // {
    //   path: '/analisis-seccion',
    //   name: 'anlisisseccion',
    //   component: () => import('./components/AnalisisSeccion.vue')
    // },
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['login', 'login2', 'logout', 'staffcontrol', 'loginsys4'];
  const authRequired = !publicPages.includes(to.name);
  const loggedIn = localStorage.getItem('user');
  
  if (authRequired && !loggedIn) {
    if (authRequired){
      if (!Vue.prototype.isSys4Conjunto()) {
        next('/login');
      } else {
        // next()
      }
    } else {
      comprobarPermiso(to.name);
    }
  } else {
    comprobarPermiso(to.name);
  }
  //miramos los permisos del usuario si puede acceder a las páginas por si meten la url por el navegador
  function comprobarPermiso(direccion) {
    switch (direccion) {
      case 'dashboard':
        if (Vue.prototype.permitido('MOBILESTORE.BI') && !Vue.prototype.isSys4Conjunto()) {
          next()
        }
        break
      case 'calenlab':
        if (Vue.prototype.permitido('MOBILESTORE.GESTIONTIENDA.CALENDARIO')) {
          next()
        }
        break
      case 'citaprevia':
        if (Vue.prototype.permitido('MOBILESTORE.GESTIONTIENDA.CITAPREVIA')) {
          next()
        }
        break
      case 'personal':
        if (Vue.prototype.permitido('MOBILESTORE.CONTROLUSER') || store.getters.isAdminSYS4) {
          next()
        }
        break
      case 'anadirempleado':
        if (Vue.prototype.permitido('MOBILESTORE.CONTROLUSER.NEWVEND')) {
          next()
        }
        break
      case 'looks':
        if (Vue.prototype.permitido('MOBILESTORE.LOOKS')) {
          next()
        }
        break
      case 'lookcreator':
        if (Vue.prototype.permitido('MOBILESTORE.LOOKS.CRUD')) {
          next()
        }
        break
      case 'weblinks':
        if (Vue.prototype.permitido('MOBILESTORE.WORKSPACE.WEBLINKS') && !Vue.prototype.isSys4Conjunto()) {
          next()
        }
        break
      case 'notas':
        if (Vue.prototype.permitido('MOBILESTORE.WORKSPACE.NOTAS') && !Vue.prototype.isSys4Conjunto()) {
          next()
        }
        break
      case 'listaclientes':
        if (Vue.prototype.permitido('MOBILESTORE.CLIENTELING') && !Vue.prototype.isSys4Conjunto()) {
          next()
        }
        break
      case 'timeline':
        if (Vue.prototype.permitido('MOBILESTORE.TIMELINE') && !Vue.prototype.isSys4Conjunto()) {
          next()
        }
        break
      case 'tienda':
        if (Vue.prototype.permitido('MOBILESTORE.TIENDA')) {
          next()
        }
        break
      case 'settings':
          if (!Vue.prototype.permitido('MOBILESTORE.SETTINGS') && !Vue.prototype.isSys4Conjunto()) {
            next()
          }
          break
      // case 'informes':
      //   if (Vue.prototype.permitido('MOBILESTORE.INFORMES')) {
      //     next()
      //   }
      // break
      default: 
        next()
    }
  }
})

export default router;
